import React from "react"
import Link from "gatsby-link"
import style from "./index.module.css";

export default () =>
  <Link to="/" className={style.main}><div className={style.text}>Spiegel voor ondernemers en wereldverbeteraars</div></Link>


// WEBPACK FOOTER //
// ./src/components/Banner/index.js